module.exports = __webpack_public_path__ + "5dc86857bfdb35c79a56f3282acca102.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-48.png
// module id = 129
// module chunks = 0